import { Key, useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import './_AvailableDataFeed.scss';
import { litrals } from '../../../../../constants/Litrals';
import { useHistory } from 'react-router-dom';
import AvailableFeedsCard from '../../molecules/AvailableFeedsCard';
import NoAvailableFeed from '../../molecules/NoAvailableFeed';
import DataFeedModal from '../../molecules/DataFeedModal';
import noDataErrorImage from '../../../../../assets/images/feeds_error_message.svg';
import noDataImage from '../../../../../assets/images/no_feeds_message.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from '../../../../../store';
import { getAvailableFeedData } from './AvailableDataFeed.actions';
import { breadcrumbsLinks } from '../../../../../constants/Constants';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';

const AvailableDataFeed = () => {
  const { accounts } = useMsal();
  //   const [showModal, setShowModal] = useState(false);
  //   const [modalData, setModaldata] = useState(null);
  const history = useHistory();

  //   const handleModal = (info: any) => {
  //     setShowModal(true);
  //     setModaldata(info);
  //   };

  const dispatch = useDispatch();

  const availableDataFeeds: any = useSelector<RootStore>((state) =>
    state.availableDataFeed.availableFeeds.sort(
      (a: { displayOrder: number }, b: { displayOrder: number }) =>
        a.displayOrder > b.displayOrder ? 1 : -1,
    ),
  );

  const availableDataFeedsError: any = useSelector<RootStore>(
    (state) => state.availableDataFeed.error,
  );

  const loading: any = useSelector<RootStore>(
    (state) => state.availableDataFeed.loading,
  );

  const emailAddress = (accounts && accounts[0] && accounts[0].username) || '';
  const userId = (accounts && accounts[0] && accounts[0].localAccountId) || '';

  useEffect(() => {
    const params = {
      emailAddress: emailAddress,
    };
    dispatch(getAvailableFeedData(params));
  }, []);

  return (
    <Row
      className="availabledata-feed-container"
      data-testid="available-feed-container"
    >
      {!loading ? (
        <Container>
          {!availableDataFeedsError && availableDataFeeds?.length ? (
            <Breadcrumbs links={breadcrumbsLinks.availableSubscriberFeed} />
          ) : null}
          <Row>
            {!availableDataFeedsError && availableDataFeeds?.length ? (
              <Col className="inner-container">
                <h4 className="section-heading">
                  {litrals.availableDataFeeds}
                </h4>
                <p className="content-paragraph">
                  {litrals.dataFeedsDelivered}
                </p>
                {availableDataFeeds.map(
                  (
                    item: {
                      feedTypeName: string;
                      subscriptionFeedTypeID: string;
                    },
                    index: Key,
                  ) => {
                    return (
                      <AvailableFeedsCard
                        key={index}
                        feedname={item.feedTypeName}
                        // onInfoIconClick={() => handleModal(item)}
                        onButtonClick={() => {
                          history.push({
                            pathname: `/subscriberportal/configuredatafeed/${item.subscriptionFeedTypeID}`,
                            state: {
                              data: item,
                              emailAddress: emailAddress,
                              userId: userId,
                              action: 'add',
                            },
                          });
                        }}
                      />
                    );
                  },
                )}
                {/* <DataFeedModal
                  onClose={() => setShowModal(false)}
                  show={showModal}
                  title={modalData?.feedTypeName}
                  content={modalData?.description}
                /> */}
              </Col>
            ) : (
              !availableDataFeedsError && (
                <Col className="inner-container">
                  <NoAvailableFeed
                    image={noDataImage}
                    message={litrals.noAvailavleDatafeedText}
                  />
                </Col>
              )
            )}
            {availableDataFeedsError && (
              <Col className="inner-container">
                <NoAvailableFeed
                  image={noDataErrorImage}
                  message={litrals.noAvailavleDatafeedErrorText}
                />
              </Col>
            )}
          </Row>
        </Container>
      ) : (
        <Spinner className="datafeed-loader" animation="border" role="status" />
      )}
    </Row>
  );
};
export default AvailableDataFeed;
